export default "__VITE_ASSET__pdZXQxFP__"